/* eslint-disable camelcase */
import * as pc from 'playcanvas';
import {Shader_Arc} from './Shaders/Shader_Arc';
import {Shader_BreatheButton} from './Shaders/Shader_BreatheButton';
import {Shader_LoaderCurtain} from './Shaders/Shader_LoaderCurtain';
import {Shader_TurbulentDisplace} from './Shaders/Shader_TurbulentDisplace';

export const MaterialManager = {
  shaders: {},
  vertAssets: {},
  fragAssets: {},
  shaderMaterials: {},
  materials: {},
  turbulenceTimes: {},
  init: function(playcanvasApp) {
    MaterialManager.playcanvasApp = playcanvasApp;
    // Setup shaders
    this.buildShader('loaderCurtain', Shader_LoaderCurtain);
    this.buildShader('arc1', Shader_Arc);
    this.buildShader('arc2', Shader_Arc);
    this.buildShader('breatheBtn', Shader_BreatheButton);
    this.buildShader('turbulentDisplace', Shader_TurbulentDisplace);
  },

  ////////////////////////////////////////////////////////////////
  // SHADER material logic
  ////////////////////////////////////////////////////////////////

  buildShader: function(name, obj) {
    const shaderDefinition = {
      attributes: {
        vertex_position: pc.SEMANTIC_POSITION,
        vertex_normal: pc.SEMANTIC_NORMAL,
        vertex_texCoord0: pc.SEMANTIC_TEXCOORD0,
      },
      vshader: obj.vert,
      fshader: obj.frag,
    };

    const shader = new pc.Shader(this.playcanvasApp.graphicsDevice, shaderDefinition);
    this.shaders[name] = shader;
    this.createShaderMaterial(shader, name);
  },

  createShaderMaterial: function(shader, name) {
    const mat = new pc.Material();
    mat.name = name;
    mat.shader = shader;
    mat.blendType = pc.BLEND_NORMAL;
    mat.depthWrite = true;
    mat.update();
    this.shaderMaterials[name] = mat;
  },
  getShader: function(name) {
    return this.shaders[name];
  },
  getShaderMaterial: function(name) {
    return this.shaderMaterials[name];
  },
  setUniform: function(materialName, uniformName, value) {
    const mat = this.shaderMaterials[materialName];
    if (!mat) {
      console.log('material not found:  ' + materialName);
    }
    mat.setParameter(uniformName, value);
  },
  setUniforms: function(materialName, data) {
    const mat = this.shaderMaterials[materialName];

    for (const uniformName in data) {
      if (Object.hasOwnProperty.call(data, uniformName)) {
        const value = data[uniformName];
        mat.setParameter(uniformName, value);
      }
    }
  },

  createTurbulentImageMaterial: function(name, imageAsset, timeOffset = 0) {
    const mat = new pc.StandardMaterial();
    mat.name = name;
    mat.depthWrite = true;
    mat.cull = pc.CULLFACE_NONE;
    mat.emissiveMap = imageAsset.resource;
    mat.emissiveIntensity = 1;
    mat.shininess = 0;
    mat.useLighting = false;
    mat.useGammaTonemap = true;

    mat.opacityMap = imageAsset.resource;
    mat.blendType = pc.BLEND_PREMULTIPLIED;
    mat.opacity = 1;

    mat.shader = this.getShader('turbulentDisplace');
    this.shaderMaterials[name] = mat;
    this.setUniforms(name, {
      uTime: 0,
      strength: 1,
    });
    mat.update();
    this.shaderMaterials[name] = mat;
    this.turbulenceTimes[name] = 0;
    return mat;
  },

  ////////////////////////////////////////////////////////////////
  // Plant material logic
  ////////////////////////////////////////////////////////////////
  createMaterial: function(name, textureAsset, useLighting = false, transparent = false) {
    const mat = new pc.StandardMaterial();
    mat.name = name;
    mat.depthWrite = true;
    mat.cull = pc.CULLFACE_NONE;
    mat.emissiveMap = textureAsset.resource;
    mat.emissiveIntensity = 1;
    mat.shininess = 0;
    mat.useLighting = useLighting;
    mat.useGammaTonemap = true;

    if (transparent) {
      mat.opacityMap = textureAsset.resource;
      mat.blendType = pc.BLEND_PREMULTIPLIED;
    }
    mat.opacity = 1;
    this.materials[name] = mat;
    mat.update();
    return mat;
  },
  getMaterial: function(name) {
    return this.materials[name];
  },

  updateTurbulance: function(dt) {
    for (const tName in this.turbulenceTimes) {
      if (Object.hasOwnProperty.call(this.turbulenceTimes, tName)) {
        const value = this.turbulenceTimes[tName];
        this.turbulenceTimes[tName] = value + dt;
        this.setUniform(tName, 'uTime', value + dt);
      }
    }
  },
};
